import { render, staticRenderFns } from "./indexView.vue?vue&type=template&id=d08f150e&scoped=true"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08f150e",
  null
  
)

export default component.exports